<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-sidenav v-if="sidenavEnabled" />
      <div class="layout-container" :class="{ 'layout-without-sidebar': !sidenavEnabled }">
        <app-navbar :sidenav-enabled="sidenavEnabled" />
        <div class="layout-content">
          <router-view />
        </div>
      </div>
    </div>
    <div class="layout-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppNavbar from '@/components/core/AppNavbar.vue'
import AppSidenav from '@/components/core/AppSidenav.vue'
import * as PN from '@/utils/PermissionNames'
import { SIDENAV_CLASSES } from '@/store'

export default {
  components: {
    AppNavbar,
    AppSidenav
  },
  computed: {
    ...mapGetters('rbac', ['can']),
    sidenavEnabled() {
      return (
        this.can(PN.FLOOR_UPDATE) ||
        this.can(PN.POINT_UPDATE) ||
        this.can(PN.EMPLOYEE_UPDATE) ||
        this.can(PN.USER_CRUD) ||
        this.can(PN.PERMISSION_CRUD)
      )
    }
  },
  methods: {
    ...mapActions(['setSidenavClass'])
  },
  watch: {
    sidenavEnabled: {
      immediate: true,
      handler(current) {
        this.setSidenavClass(current ? false : SIDENAV_CLASSES.disabled)
      }
    }
  }
}
</script>
<style>
.layout-without-sidebar {
  padding-left: 0 !important;
}
</style>
